import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CustomNavbar from './components/Navbar';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';

import ItemList from './components/Items/ItemList';
import ItemDetail from './components/Items/ItemDetail';
import ItemForm from './components/Items/ItemForm';

import CategoryList from './components/Categories/CategoryList';
import CategoryForm from './components/Categories/CategoryForm';

import MaterialList from './components/Materials/MaterialList';
import MaterialForm from './components/Materials/MaterialForm';

import OrdersList from './components/Orders/Orders';

import LayoutingPage from './components/Layouting/LayoutingPage';
import PackagingPage from './components/Packaging/Packaging';
import PrintingPage from './components/Printing/PrintingPage';
import CuttingPage from './components/Cutting/CuttingPage';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css'; // Подключаем Bootstrap CSS
import './index.css'; // Ваши кастомные стили, если есть
import UserList from './components/Users/UserList';
import UserDetails from './components/Users/UserDetails';
import ImportItemsPage from './components/Items/ImportItems';
import ImportCdrFilesPage from './components/Items/ImportCdrFiles';
import WarehouseItemList from './components/Warehouse/WarehouseItemList';

const App = () => {

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Проверяем авторизацию при загрузке приложения
  useEffect(() => {
    const token = localStorage.getItem('access_token');
    setIsAuthenticated(!!token);
  }, []);

  return (
    <Router>
      <CustomNavbar isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
      <Routes>
        <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
        <Route path="/register" element={<Register setIsAuthenticated={setIsAuthenticated} />} />
        
        <Route exact path="/items" element={<ItemList />} />
        <Route path="/items/new" element={<ItemForm/>} />
        <Route path="/items/:id/edit" element={<ItemForm/>} />
        <Route path="/items/:id" element={<ItemDetail />} />
        <Route path="/items/import" element={<ImportItemsPage />} />
        <Route path="/cdrfiles/import" element={<ImportCdrFilesPage />} />
        
        <Route exact path="/categories" element={<CategoryList/>} />
        <Route path="/categories/new" element={<CategoryForm/>} />
        <Route path="/categories/:id/edit" element={<CategoryForm/>} />
        
        <Route exact path="/materials" element={<MaterialList/>} />
        <Route path="/materials/new" element={<MaterialForm/>} />
        <Route path="/materials/:id/edit" element={<MaterialForm/>} />

        <Route path="/orders" element={<OrdersList/>} />
        <Route path="/layouting" element={<LayoutingPage/>} />
        <Route path="/printing" element={<PrintingPage/>} />
        <Route path="/cutting" element={<CuttingPage/>} />
        <Route path="/packaging" element={<PackagingPage/>} />
        <Route path="/warehouse" element={<WarehouseItemList/>} />
        
        <Route path="/users" element={<UserList/>} />
        <Route path="/users/:userId" element={<UserDetails/>} />

        <Route path="/" element={<ItemList />} />
      </Routes>
    </Router>
  );
};

export default App;